import { useState, useEffect, useCallback } from 'react';
import { collection, addDoc, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';

export const useCollections = (collectionName) => {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(false); // Start as false
  const [error, setError] = useState(null);

  const fetchCollections = useCallback(async () => {
    if (!collectionName || typeof collectionName !== 'string' || collectionName.trim() === '') {
      setError('Valid collection name is required');
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    
    try {
      const querySnapshot = await getDocs(collection(db, collectionName.trim()));
      const collectionData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      setCollections(collectionData);
    } catch (err) {
      console.error('Error fetching collections:', err);
      setError('Could not fetch collections: ' + err.message);
    } finally {
      setLoading(false);
    }
  }, [collectionName]);

  useEffect(() => {
    fetchCollections();
  }, [fetchCollections]);

  const addDocument = async (documentData) => {
    try {
      setLoading(true);
      const docRef = await addDoc(collection(db, collectionName), documentData);
      
      // Refresh collections after adding a document
      await fetchCollections();
      
      setLoading(false);
      return docRef;
    } catch (err) {
      setError('Could not add document');
      setLoading(false);
      console.error(err);
      return null;
    }
  };

  return { 
    collections, 
    loading, 
    error, 
    fetchCollections,
    addDocument 
  };
};